<template>
  <div class="bg-secondary pb-5">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>

    <div
      v-if="
        consultantstatus &&
        consultantstatus.can_do_survey === '0' &&
        consultantstatus.can_do_elearning === '0'
      "
      class="my-5"
    >
      <LearningHub />
    </div>

    <div class="mx-auto container-xl">
      <div v-if="consultantstatus && consultantstatus.can_do_survey === '1'">
        <div class="surveylist">
          <div id="my-surveys" class="title-area">
            <div class="row mt-5">
              <div class="col-md-8 col-12">
                <h1 class="page-title h2">
                  Welcome {{ user.first_name }} {{ user.family_name }}
                  <!-- TODO: Update screentext -->
                </h1>
                <div>
                  <p v-html="intro_text"></p>
                  <!-- TODO: Update screentext -->
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div>
                  <strong class="d-block mb-2">Quick links</strong>
                  <a class="d-block mb-2" href="/tutorials">Tutorials</a>
                  <a class="d-block mb-2" href="mailto:info@gdq.se">Support</a>
                  <!-- TODO: Update screentext? -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="island-grid" no-gutters="true">
          <div class="island">
            <div class="island-header">
              <div
                class="island-title d-flex justify-content-between align-items-center"
              >
                <a href="/surveys">
                  <i class="fa-regular fa-square-poll-vertical"></i>
                  <h2>My surveys</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <router-link to="/create">
                  <button class="btn btn-secondary" type="button">
                    <i class="fa fa-regular fa-plus me-2"></i>New survey
                  </button>
                </router-link>
              </div>
            </div>
            <div class="island-table">
              <Surveys />
            </div>
          </div>

          <div class="island">
            <div class="island-header">
              <div
                class="island-title d-flex justify-content-between align-items-center"
              >
                <a href="/foldersgroups">
                  <i class="fa-regular fa-square-poll-vertical"></i>
                  <h2>My folders and groups</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <router-link to="/create/group">
                  <button class="btn btn-secondary" type="button">
                    <i class="fa fa-regular fa-plus me-2"></i>New group
                  </button>
                </router-link>
              </div>
            </div>
            <div class="island-table">
              <Folders @reload-dashboard="reloadDashboard" />
            </div>
          </div>

          <div
            v-if="learninghubCert.length > 0"
            class="island island-prominent"
          >
            <div class="island-header">
              <div
                class="island-title d-flex justify-content-between align-items-center"
              >
                <a href="/learninghub">
                  <i class="fa-regular fa-graduation-cap"></i>
                  <h2>Learning Hub</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <router-link :to="learninghubContinuePath">
                  <button class="btn btn-primary" type="button">
                    <i class="fa fa-regular fa-circle-play me-2"></i>Continue
                    learning
                  </button>
                </router-link>
              </div>
            </div>
            <div class="island-table">
              <LearningHubIsland track="certification" />
            </div>
          </div>

          <div v-if="learninghubOther.length > 0" class="island">
            <div class="island-header">
              <div
                class="island-title d-flex justify-content-between align-items-center"
              >
                <a href="/learninghub">
                  <i class="fa-regular fa-graduation-cap"></i>
                  <h2>Learning Hub</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
              </div>
            </div>
            <div class="island-table">
              <LearningHubIsland track="other" />
            </div>
          </div>

          <!-- div class="island">
            <div class="island-header">
              <div class="island-title d-flex justify-content-between align-items-center">
                <a href="/reports">
                  <i class="fa-regular fa-file-chart-column"></i>
                  <h2>My aggregated reports</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <router-link to="/aggregatedreports">
                  <button class="btn btn-secondary" type="button"><i class="fa fa-regular fa-plus me-2"></i>New report</button>
                </router-link>
              </div>
            </div>
            <div class="island-table">
              <MyAggregatedReports />
            </div>
          </div -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Navbar from "./Navbar.vue";
import Surveys from "./dashboard/Surveys.vue";
import Folders from "./dashboard/Folders.vue";
import LearningHub from "./LearningHub.vue";
import LearningHubIsland from "./dashboard/LearningHubIsland.vue";

// Initialize store
const store = useStore();

// Refs for component data
const screen_id = ref(1);
const screentexts = ref([]);
const intro_text = ref(
  "Welcome to <strong>My GDQ Management</strong>. Here, you can easily create, organise, and manage your surveys and reports, all in one place. Set up a clear folder structure to gain an enhanced overview of your groups and surveys. Track the progress of ongoing or scheduled surveys, send timely reminders, add new participants, and export detailed reports."
);

// Reactive state from store
const profile = computed(() => store.state.profile);
const user = computed(() => store.state.user);
const learninghubMy = computed(() => store.state.learninghub.my);

// Computed properties
const consultantstatus = computed(() => {
  if (!profile.value || !profile.value.consultantstatus_id) {
    return null;
  }
  const statuses = store.state.consultantstatuses;
  if (!statuses || !Array.isArray(statuses)) {
    return null;
  }
  const status = statuses.find(
    (s) => s.id === profile.value.consultantstatus_id
  );
  return status || null;
});

const learninghubCert = computed(() =>
  learninghubMy.value.filter((e) => e.track === "certification")
);

const learninghubOther = computed(() =>
  learninghubMy.value.filter((e) => e.track !== "certification")
);

const learninghubContinuePath = computed(() => {
  if (learninghubCert.value.length === 1) {
    return "/learninghub/" + learninghubCert.value[0].slug;
  }
  return "/learninghub";
});

// Methods
const reloadDashboard = () => {
  store.dispatch("group_clear");
  store.dispatch("survey_clear");
  store.dispatch("setcurrentaggregatedreport_id", { report_id: 0 });
  profile_get();
  user_usergroups_get();
  fetchGlobalData();
};

const profile_get = () => {
  return store.dispatch("profile_fetch", {});
};

const user_usergroups_get = () => {
  return store.dispatch("user_usergroups_fetch").then((resp) => {
    return resp;
  });
};

const fetchGlobalData = async () => {
  const needsCountries = !store.state.countries || store.state.countries.length === 0;
  const needsFormOptions = !store.state.formoptions || store.state.formoptions.length === 0;
  const needsStatuses = !store.state.consultantstatuses || store.state.consultantstatuses.length === 0;
  const needsScreentexts = !store.state.screentexts || store.state.screentexts.length === 0;

  const fetches = [];
  if (needsCountries) fetches.push(store.dispatch("countries_fetch"));
  if (needsFormOptions) fetches.push(store.dispatch("formoptions_fetch"));
  if (needsStatuses) {
    fetches.push(store.dispatch("consultantstatuses_fetch"));
  }
  if (needsScreentexts) {
    const filter = {
      screen_id: { operator: "=", value: screen_id.value },
    };
    fetches.push(store.dispatch("systemscreenelements_fetch", { filter }).then((resp) => {
      const dbtexts = resp.data.result || [];
      const screentexts_local = {};
      for (let i = 0; i < dbtexts.length; i++) {
        screentexts_local[dbtexts[i].id] = {
          id: dbtexts[i].id,
          element_text: dbtexts[i].element_text,
          element_bubbletext: dbtexts[i].element_bubbletext,
        };
      }
      screentexts.value = screentexts_local;
      if (screentexts_local[180]) {
        intro_text.value = screentexts_local[180].element_text;
      }
      return resp;
    }));
  }

  return Promise.all(fetches);
};

// Lifecycle hook
onMounted(async () => {
  store.dispatch("group_clear");
  store.dispatch("survey_clear");
  store.dispatch("setcurrentaggregatedreport_id", { report_id: 0 });
  
  await Promise.all([
    profile_get(),
    user_usergroups_get(),
    store.dispatch("learninghub_my_fetch").catch(() => {}),
  ]);
  
  await fetchGlobalData();
});
</script>

<style scoped>
.island-title a {
  text-decoration: none;
  color: inherit;
}

.island-title a:hover {
  text-decoration: none;
}

.island-prominent {
  order: -1;
  grid-column: 1 / -1;
  border: 2px solid #007a8f;
}
</style>
